<template>
    <BasePage :model="{
        title: translations['article.RelatedArticle.SectionTitle']
    }">
        <div class="related-articles-container">
            <a class="article-card" v-for="article in relatedArticles" :href="article.url">
                <img v-if="article.image" :src="article.image.url" :alt="article.image.text" :title="article.image.text"
                    class="article-image" />
                <div class="article-description">
                    <h5>{{ article.title }}</h5>
                    <p class="date">Posted on {{ longLocalDate(culture, article.createDate) }}</p>
                </div>
            </a>
        </div>
    </BasePage>
</template>
<script lang="ts" setup>
import BasePage from '@/components/Common/BasePage/BasePage.vue';
import { IRelatedArticlesProps } from './RelatedArticles.model';
import { computed } from 'vue';
import { longLocalDate } from '@/share/util';


const { relatedArticles, translations } = defineProps<IRelatedArticlesProps>()
const culture = computed(() => window.__STATE__?.culture ?? "")
</script>
<style lang="scss" scoped>
.related-articles-container {
    border-radius: 0 0 24px 24px;
    border: 1px solid lightgray;
    border-top: 0;
    padding: 24px 30px;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 10px
}

.article-card {
    min-height: 220px;
    width: 100%;
    border-radius: 24px;
    border: 1px solid lightgray;

    .article-image {
        border-radius: 24px 24px 0 0;
        width: 100%;
        height: 150px;
        object-fit: cover;
    }

    .article-description {
        padding: 12px 15px;

        h5 {
            color: var(--primary);
            font-weight: 700;
        }

        .date {
            font-weight: 300;
            font-size: 0.75rem;
        }
    }
}

@media (min-width: 768px) {
    .related-articles-container {
        flex-direction: row;
    }

    .article-card {
        width: 300px;
    }
}
</style>